import React, { useState } from 'react'
import { Search } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { QueryParams } from '../../../pages/home-page/home-component/home.constants'
import { setQueryParams } from '../../../store/home-page-items/reducer'
import { useAppHeaderSearchStyles } from './app-header-search.styles'

export const AppHeaderSearch: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderSearchStyles()
  const navigate = useNavigate()
  const [searchPayload, setSearchPayload] = useState<string>('')
  const dispatch = useDispatch()

  const submitSearchHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    navigate(`/search?searchText=${searchPayload}`)
    changeQueryParamsAction({ searchText: searchPayload }, true, true)
  }

  const changeQueryParamsAction = (
    data: QueryParams,
    isApply?: boolean,
    isStartPagingInBegin?: boolean
  ) => {
    dispatch(setQueryParams({ ...data, isApply, isStartPagingInBegin }))
  }

  return (
    <form className={classes.root} onSubmit={submitSearchHandler}>
      <input
        className={classes.searchInput}
        placeholder="Search"
        onChange={(e) => setSearchPayload(e.target.value)}
      />
      <button type="submit" className={classes.searchButton}>
        <Search />
      </button>
    </form>
  )
}
